var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon19(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2237",
    "data-name": "Rectangle 2237",
    width: 35,
    height: 35,
    transform: "translate(0 0)",
    fill: "#ffe800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10215",
    "data-name": "Group 10215",
    transform: "translate(0 -0.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10214",
    "data-name": "Group 10214",
    transform: "translate(0 0.334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27577",
    "data-name": "Path 27577",
    d: "M11.494,34.94A11.507,11.507,0,0,1,8.787,12.252V8.967a4.6,4.6,0,1,1,2.929,0v2.959h8.578a1.464,1.464,0,1,1,0,2.929H11.716V18.2H24.059a1.465,1.465,0,0,1,1.31.809l4.453,8.906,2.561-.854a1.465,1.465,0,1,1,.926,2.779L29.544,31.1a1.464,1.464,0,0,1-1.773-.734l-4.616-9.233h-12.9a1.464,1.464,0,0,1-1.464-1.464V15.3a8.578,8.578,0,1,0,10.67,11.36,1.464,1.464,0,1,1,2.714,1.1,11.542,11.542,0,0,1-10.677,7.18M10.251,2.929A1.674,1.674,0,1,0,11.925,4.6a1.676,1.676,0,0,0-1.674-1.674",
    transform: "translate(0 -0.33)",
    fill: "#ffe800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon19);
export default __webpack_public_path__ + "static/media/social_icon19.eac61f69083103bef0f591544d4714f6.svg";
export { ForwardRef as ReactComponent };